import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../services/user.service";
import { ToastrService } from "ngx-toastr";
import { IUser } from "../User";
import { Title } from "@angular/platform-browser";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { CustomValidators } from "../custom-validators";

@Component({
  selector: "app-user-changepassword",
  templateUrl: "./admin-changepassword.component.html",
  styleUrls: ["./admin-changepassword.component.scss"],
})
export class AdminChangepasswordComponent implements OnInit {
  public loading = false;

  public user: IUser;
  public errors: any = {};

  public frmSignup: FormGroup;
  public notify: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private toastr: ToastrService,
    private title: Title,
    private fb: FormBuilder
  ) {
    this.user = this.userService.initialize();
    this.title.setTitle("User Profile");
    this.frmSignup = this.createSignupForm();
  }

  ngOnInit() {
    const userId = this.route.snapshot.params.id;
    this.userService.getById(userId).subscribe((user) => {
      this.user = user;
    });
    this.notify = false;
  }

  changePassword() {
    const template = `Hello ${this.user.name}.\nYour new password: ${this.frmSignup.value.repeat_password}`;
    this.frmSignup.controls.subject.setValue("Your password has been changed");
    this.frmSignup.controls.body.setValue(template);
    this.frmSignup.value.repeat_password
      ? this.frmSignup.controls.notify.enable()
      : this.frmSignup.controls.notify.disable();
  }

  savePassword() {
    if (this.frmSignup.valid) {
      this.loading = true;
      let userData = this.frmSignup.value;
      userData["userid"] = this.route.snapshot.params.id;

      this.userService.changePasswordAdmin(userData).subscribe((result) => {
        this.loading = false;
        if (result.errors) {
          this.errors = result.errors;
        } else {
          this.router.navigate([
            "user/profile/" + this.route.snapshot.params.id,
          ]);
        }
      });
    } else {
      this.toastr.error("Validations failed.", "error");
    }
  }

  onCancel() {
    this.router.navigate(["user/profile/" + this.route.snapshot.params.id]);
  }

  createSignupForm(): FormGroup {
    return this.fb.group(
      {
        new_password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true,
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true,
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(/[!#$.]/, {
              hasSpecialCharacters: true,
            }),
            Validators.minLength(8),
          ]),
        ],
        repeat_password: [null, Validators.compose([Validators.required])],
        old_password: [null, Validators.compose([Validators.required])],
        notify: new FormControl({ value: "", disabled: true }),
        subject: new FormControl(),
        body: new FormControl(),
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator,
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/admin-changepassword/admin-changepassword.component.ts